/**
 * @fileoverview PATCH handler for the "/companies/:company_id/mobile_app_linking_configs/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { patchCompaniesCompanyIdMobileAppLinkingConfigsIdCacheKeys } from "./constants";
import type {
  PatchCompaniesCompanyIdMobileAppLinkingConfigsIdProps,
  PatchCompaniesCompanyIdMobileAppLinkingConfigsIdResult,
} from "./types";

export const patchCompaniesCompanyIdMobileAppLinkingConfigsId = reactQueryMutationAdapter(
  patchCompaniesCompanyIdMobileAppLinkingConfigsIdCacheKeys,
  ({
    companyId,
    id,
    name,
  }: PatchCompaniesCompanyIdMobileAppLinkingConfigsIdProps): Promise<PatchCompaniesCompanyIdMobileAppLinkingConfigsIdResult> => {
    return fetch(`/companies/${companyId}/mobile_app_linking_configs/${id}`, "PATCH", { name }, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
